import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ROLE,
  SIZE,
} from 'baseui/modal';
import Separator from 'components/common/separator';
import { Form, Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import useYupValidationResolver from 'hooks/use-yup-validation-resolver';
import { DialogCommonStyles } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

type FormType = {
  completionDateEstimation: Date | null;
};

interface Props {
  onClose: () => void;
  onSubmit: (val: FormType) => void;
}

export default function CompletionEstimateDialog(props: Props) {
  const { t } = useTranslation();
  const defaultValues: FormType = { completionDateEstimation: null };

  const resolver = useYupValidationResolver(
    Yup.object({
      completionDateEstimation: Yup.date().nullable().required(),
    }).required(),
  );

  const methods = useForm<FormType>({
    defaultValues,
    resolver,
    mode: 'onChange',
  });

  const onSubmit = (values: FormType) => {
    props.onSubmit?.(values);
  };

  return (
    <Modal
      closeable={false}
      isOpen
      animate
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      size={SIZE.default}
      role={ROLE.dialog}
      overrides={DialogCommonStyles}
    >
      <ModalHeader>{t('common:completion_date_estimation')}</ModalHeader>
      <Form methods={methods} onSubmit={onSubmit}>
        <ModalBody>
          <Input
            type="date-time"
            name="completionDateEstimation"
            required
            hideRequiredStar
          />
        </ModalBody>
        <ModalFooter $style={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            buttonType="tertiary"
            onClick={props.onClose}
            disabled={methods.formState.isSubmitting}
          >
            {t('common:cancel')}
          </Button>
          <Separator gap={8} />
          <Input type="submit" />
        </ModalFooter>
      </Form>
    </Modal>
  );
}
